module.exports = __webpack_public_path__ + "img/medical.c1a31b2c.svg";